export const INTERVIEWS_PATH = "/interviews";
